import React, { useState } from 'react';
import { useTranslation } from '../context/LanguageContext';

interface LanguageSelectorProps {
  className?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { language, setLanguage, t, isLoadingPreference } = useTranslation();
  const [isUpdating, setIsUpdating] = useState(false);

  const toggleLanguage = async () => {
    setIsUpdating(true);
    try {
      await setLanguage(language === 'el' ? 'en' : 'el');
    } catch (error) {
      console.error('Failed to update language:', error);
      // Could add toast notification here if available
    } finally {
      setIsUpdating(false);
    }
  };

  const isDisabled = isLoadingPreference || isUpdating;

  return (
    <button
      onClick={toggleLanguage}
      disabled={isDisabled}
      className={`language-selector ${className}`}
      title={isDisabled ? t('loading') : t('changeLanguage')}
      style={{
        background: 'none',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '6px 12px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        color: isDisabled ? '#999' : '#333',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        opacity: isDisabled ? 0.6 : 1
      }}
      onMouseOver={(e) => {
        if (!isDisabled) {
          e.currentTarget.style.borderColor = '#007bff';
          e.currentTarget.style.color = '#007bff';
        }
      }}
      onMouseOut={(e) => {
        if (!isDisabled) {
          e.currentTarget.style.borderColor = '#ccc';
          e.currentTarget.style.color = '#333';
        }
      }}
    >
      {isUpdating ? '⏳' : '🌐'} {
        isLoadingPreference 
          ? t('loading') + '...'
          : language === 'el' ? t('greek') : t('english')
      }
    </button>
  );
};

export default LanguageSelector; 